/* Script Edit Mode */

$(document).ready(function() {
    //editmode:: slideToggle show/hide admin bar
    $('#topbar').hover(function() {
        $('.btntop').show();
    });

    $('.btntop').click(function() {
        $('.showtopbar').slideToggle('slow', function() {
            $('.btntop i').toggleClass('uk-icon-angle-down');
        });
    });

    $(document).scroll(function() {
        //editmode:: remove sticky menu
        if ($(this).scrollTop() > 0) {
            $('.uk-navbar').css('position', '');
            $('.uk-sticky-placeholder').removeClass('rv-sticky-overlap');
        }
    });
});
